import { createSelector } from 'reselect'
import { STORE_NAME } from 'common/reducers/accessToken'

const getStore = (state: any): any => state[STORE_NAME]

export const getToken = createSelector<any, any, any>(
  getStore,
  (store: any) => {
    return store.get('accessToken')
  }
)

export const getUuid = createSelector<any, any, any>(getStore, (store: any) =>
  store.get('uuid')
)
